import React from 'react';
import { graphql } from 'gatsby';
import { OmTabsTwoColumnLayoutImageRight } from '@om/component-library-react';
import TwoColumnImageRight from './TwoColumnImageRight';

const TabsTwoColumnImageRight = ({
    tabsTwoColumnImageRightContent,
    slot
}) => {
    if(!tabsTwoColumnImageRightContent) {
        return '';
    }

    const {
        use_heading_as_h1,
        is_extended,
        has_boundary,
        section_heading,
        section_caption,
        tab_text_one,
        two_column_image_right_one,
        tab_text_two,
        two_column_image_right_two,
        tab_text_three,
        tab_text_four,
        tab_text_five,
        tab_text_six,
        button_action_type,
        call_me_back,
        button_text,
        open_tab,
        button_url,
        two_column_image_right_three,
        two_column_image_right_four,
        two_column_image_right_five,
        two_column_image_right_six
    } = tabsTwoColumnImageRightContent;

    return (
        <OmTabsTwoColumnLayoutImageRight
            slot={slot}
            isExtended={is_extended}
            hasBoundary={has_boundary}
            tabTextOne={tab_text_one}
            tabTextTwo={tab_text_two}
            tabTextThree={tab_text_three}
            tabTextFour={tab_text_four}
            tabTextFive={tab_text_five}
            tabTextSix={tab_text_six}
            buttonText={button_text}
            buttonUrl={button_url ? button_url.href : ''}
            buttonActionType={button_action_type}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            openTab={open_tab}
        >
            {
                use_heading_as_h1 ? <h1 slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} /> :  <span slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} />
            }
            {
                section_caption ? <span slot="section-caption" dangerouslySetInnerHTML={{__html: section_caption}} /> : ''
            }
            <TwoColumnImageRight slot="two-column-image-right-one" twoColumnImageRightContent={two_column_image_right_one[0]} />
            <TwoColumnImageRight slot="two-column-image-right-two" twoColumnImageRightContent={two_column_image_right_two[0]} />
            <TwoColumnImageRight slot="two-column-image-right-three" twoColumnImageRightContent={two_column_image_right_three[0]} />
            <TwoColumnImageRight slot="two-column-image-right-four" twoColumnImageRightContent={two_column_image_right_four[0]} />
            <TwoColumnImageRight slot="two-column-image-right-five" twoColumnImageRightContent={two_column_image_right_five[0]} />
            <TwoColumnImageRight slot="two-column-image-right-six" twoColumnImageRightContent={two_column_image_right_six[0]} />
        </OmTabsTwoColumnLayoutImageRight>
    );
};

export const pageQuery = graphql`
fragment TabsTwoColumnLayoutImageRight on Contentstack_tabs_two_column_layout_image_right {
        uid
        use_heading_as_h1
        is_extended
        has_boundary
        section_heading
        section_caption
        tab_text_one
        two_column_image_right_one {
            ...TwoColumnImageRight
        }
        tab_text_two
        two_column_image_right_two {
            ...TwoColumnImageRight
        }
        tab_text_three
        tab_text_four
        tab_text_five
        tab_text_six
        button_action_type
        call_me_back {
            ...CallMeBack
        }
        button_text
        open_tab
        button_url {
            ...Link
        }
        two_column_image_right_three {
            ...TwoColumnImageRight
        }

        two_column_image_right_four {
            ...TwoColumnImageRight
        }
        two_column_image_right_five {
            ...TwoColumnImageRight
        }
        two_column_image_right_six {
            ...TwoColumnImageRight
        }
    }
`;

export default TabsTwoColumnImageRight;
